import Vue from "vue";
import { date } from "quasar";
import { CONDITIONS_TIME_PAYLOAD_FORMATS, CONDITION_TIME_USER_FORMATS } from "@/assets/js/appConfig.js";

export const evBus = new Vue();

export function normalize(data) {
    let deepData = deepCopy(data);
    if (deepData === null) {
        return [];
    }
    deepData = deepData.clone;
    const result = [];
    for (let i = 0; i < deepData.length; i += 1) {
        delete deepData[i].order;
        if (deepData[i].type === "logicOperator") {
            if (i > 0) {
                deepData[i - 1].logicOperatorAfter = deepData[i].value;
            }
            continue;
        }
        if (deepData[i].type === "group") {
            delete deepData[i].logicOperatorBefore;
            if (i > 0 && !deepData[i - 1].logicOperatorAfter && deepData[i].logicOperatorBefore) {
                deepData[i - 1].logicOperatorAfter = deepData[i].logicOperatorBefore;
            }
            deepData[i].conditions = normalize(deepData[i].conditions);
        }
        if (i === deepData.length - 1) {
            deepData[i].logicOperatorAfter = null;
        } else if (!deepData[i].logicOperatorAfter) {
            deepData[i].logicOperatorAfter = "&&";
        }
        result.push(deepData[i]);
    }
    return result;
}
export function getStatement(data) {
    const normalData = normalize(data);
    const statement = normalData.reduce((acumulator, item) => {
        if (item.val1 && item.val2) {
            if (item.logicalCondition === "isEmpty" || item.logicalCondition === "isNotEmpty") {
                acumulator += (createFunctionWrapper(item.logicalCondition, item.val1));
            } else {
                acumulator += `${formatValue(item.val1)} ${item.logicalCondition} ${formatValue(item.val2)}`;
            }
        }
        if (item.conditions) {
            acumulator += `( ${getStatement(item.conditions)} )`;
        }
        acumulator += item.logicOperatorAfter ? ` ${item.logicOperatorAfter} ` : " ";
        return acumulator;
    }, "");
    return statement;
}

function formatValue({ type = "", value = "", fieldType = "" } = {}) {
    if (type === "LOC" || type === "LOG") {
        return value || `'${value}'`;
    } if (type === "TXT") {
        value = value.replace(/(?![\\])\'/g, "\\'");
        return `'${value}'`;
    } if (type === "DATE" || type === "TIME" || type === "DTM") {
        value = formatDateAndTime(fieldType, value);
        const options = {
            DTM: {
                prefix: "+new Date(",
                suffix: ")"
            },
            TIME: {
                prefix: "+new Date('1/1/1970 ' + ",
                suffix: ")"
            }
        };
        if (options.hasOwnProperty(type)) {
            value = `${options[type].prefix}${value}${options[type].suffix}`;
        }
        return value;
    } if (type !== "MOD" && type !== "VAR") {
        return value;
    }
    const options = {
        string: {
            prefix: "'${(",
            suffix: ")!}'"
        },
        integer: {
            prefix: "${(",
            suffix: ")!'null'}"
        },
        boolean: {
            prefix: "${(",
            suffix: "?c)!'null'}"
        },
        decimal: {
            prefix: "${(",
            suffix: ")!'null'}"
        },
        date: {
            prefix: "'${(",
            suffix: ")!}'"
        },
        datetime: {
            prefix: "+new Date('${(",
            suffix: ".format())!}')"
        },
        time: {
            prefix: "+new Date('1/1/1970 ' + '${(",
            suffix: ")!}')"
        },
        attachment: {
            prefix: "'${(",
            suffix: ")!}'"
        }
    };
    fieldType = fieldType.toLowerCase();
    if (options.hasOwnProperty(fieldType)) {
        return `${options[fieldType].prefix}${value}${options[fieldType].suffix}`;
    }
    return "''";
}

// this function fails on objects containing cyclic references and returns null
export function deepCopy(obj) {
    try {
        const jsonString = JSON.stringify(obj);
        const clone = JSON.parse(jsonString);
        return { clone, jsonString };
    } catch (err) {
        return null;
    }
}

export function createFunctionWrapper(fn, val) {
    const str = val.value;
    if (val.fieldType === "string" || val.fieldType === "attachment") {
        return `\$\{${fn}((${str})!, '${val.fieldType.charAt(0).toUpperCase() + val.fieldType.slice(1)}')}`;
    }
    return `\$\{${fn}((${str})!'null', '${val.fieldType.charAt(0).toUpperCase() + val.fieldType.slice(1)}')}`;
}

export function getNestedValuesObj(data) {
    const result = {};
    for (const key in data) {
        addToNestedObject(result, key.split("."), data[key]);
    }
    return result;
}

function addToNestedObject(objRef, arr, valueToNest) {
    if (arr.length > 0) {
        const newKey = arr.shift();
        if (arr.length > 0) {
            if (objRef.hasOwnProperty(newKey)) {
                objRef = objRef[newKey];
            } else {
                objRef[newKey] = {};
                objRef = objRef[newKey];
            }
            return addToNestedObject(objRef, arr, valueToNest);
        }
        objRef[newKey] = valueToNest !== undefined ? valueToNest.replace(/(?![\\])\'/g, "\\'") : "";
    }
}
export function getConcatLabel(value, conditionInput) {
    let variableBgColor = "";
    const variableCheck = value.substring(0, 2);
    if (variableCheck === "m_") {
        variableBgColor = "#bf4ae2";
        value = value.replace("m_", "");
    } else if (variableCheck === "s_") {
        variableBgColor = "#F29500";
        value = value.replace("s_", "");
    }
    if (variableBgColor) {
        let result;
        const splittedValue = value.split(".");
        const formattedLabel = splittedValue.pop();
        const chipValue = splittedValue[splittedValue.length - 1];

        if (conditionInput) {
            const prefix = `<span class="${variableCheck === "m_" ? "datamodel-variable-format" : "system-variable-format"}">
            <span class="${variableCheck === "m_" ? "inner-data-model" : "inner-system-variable"}">${chipValue}</span>${formattedLabel}</span>`;

            result = { value: formattedLabel, prefix };
        } else {
            const chipContainer = `<span class="tooltiptext" style="margin-bottom:10px">${value}</span>`;

            const labelValue = `<span class="${variableCheck === "m_" ? "datamodel-variable-format" : "system-variable-format"} ellipsis">
            <span class="${variableCheck === "m_" ? "inner-data-model" : "inner-system-variable"}">${chipValue}</span>${formattedLabel}</span>`;

            const labelContainer = `<span class="conditions-label-container q-px-xs bg-white">${chipContainer}${labelValue}</span>`;
            result = labelContainer;
        }
        return result;
    }
    console.error("Variable Name Is Not Valid");
}
export function formatDateAndTime(type, value, userReadable) {
    let result = null;
    if (userReadable) {
        if (CONDITION_TIME_USER_FORMATS.hasOwnProperty(type)) {
            result = date.formatDate(value, CONDITION_TIME_USER_FORMATS[type]);
        }
    } else {
        if (CONDITIONS_TIME_PAYLOAD_FORMATS.hasOwnProperty(type)) {
            result = date.formatDate(value, CONDITIONS_TIME_PAYLOAD_FORMATS[type]);
        }
        result = result ? `'${result}'` : "''";
    }
    return result;
}
